import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';

import { DynamicLayoutSlotComponent } from '../dynamic-layout/dynamic-layout-slot.component';
import { DynamicLayoutService, SlotName } from '../dynamic-layout/dynamic-layout.service';

/**
 * @stable
 */
@Component({
    imports: [RouterModule, DynamicLayoutSlotComponent],
    selector: 'vn-main',
    templateUrl: 'main.html',
})
export class MainComponent {
    readonly SlotName = SlotName;
    readonly dynamicLayoutService = inject(DynamicLayoutService);
}
